import React from "react";
import styles from "./electricVehicleExemptionAlert.module.scss";
import { electricCarImage } from "./electricCarAsset";

export interface ElectricVehicleExemptionAlertProps {
  title: string;
  description: string;
  highlightText: string;
}

export default function ElectricVehicleExemptionAlert(props: ElectricVehicleExemptionAlertProps) {
  const { title, description, highlightText } = props;

  const renderDescription = () => {
    if (!highlightText) {
      return description;
    }

    const parts = description.split(highlightText);
    if (parts.length === 1) {
      return description;
    }

    return (
      <>
        {parts[0]}
        <span className={styles.highlight}>{highlightText}</span>
        {parts[1]}
      </>
    );
  };

  return (
    <div className={styles.exemptionBox}>
      <div className={styles.content}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{renderDescription()}</p>
      </div>
      <img src={electricCarImage} alt="" className={styles.carImage} />
    </div>
  );
}
